import { PropsWithChildren } from "react";

interface TableBodyProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {}

export const TableBody = ({ children, ...props }: TableBodyProps) => {
  return (
    <div className="block mt-8" {...props}>
      {children}
    </div>
  );
};
